import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as ArrowUpIcon } from "../../assets/svg/arrow-up.svg";

const CustomDropdownWithSearchStatic = ({
    onChangeIndex = {},
    onDropdownChange,
    placeholder,
    selectedValue,
    selectedOption,
    options = [],
    disabled = false,
    isSearch = true
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(options);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (searchTerm === "") {
            setFilteredOptions(options);
        } else {
            setFilteredOptions(
                options.filter((option) =>
                    option.label.toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
        }
    }, [searchTerm, options]);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        if (disabled) return;
        setIsOpen((prev) => !prev);
    };

    const selectOption = (option) => {
        if (Object.keys(onChangeIndex).length === 0) {
            onDropdownChange(option);
        } else {
            onDropdownChange(option, onChangeIndex);
        }
        setIsOpen(false);
    };

    return (
        <div ref={dropdownRef} style={{ position: "relative", height: "40px" }}>
            <div
                onClick={toggleDropdown}
                style={{
                    height: "40px",
                    padding: "10px",
                    border: isOpen ? "1px solid #6929E2" : "1px solid #E5E5E5",
                    borderRadius: "8px",
                    cursor: disabled ? "not-allowed" : "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: disabled ? "#f5f5f5" : "#FFFFFF",
                    color:
                        disabled
                            ? "#B0B0B0"
                            : selectedOption || selectedValue !== ""
                                ? "#1E1E1E"
                                : "#81878C",
                    fontSize: "14px",
                    fontWeight: "500"
                }}
            >
                <span
                    style={{
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        color: selectedOption || selectedValue ? "#1E1E1E" : "#81878C", // dark text if selected, gray if placeholder
                    }}
                >
                    {selectedOption
                        ? selectedOption.label
                        : selectedValue
                            ? selectedValue
                            : placeholder}
                </span>

                <span style={{ marginLeft: "10px" }}>
                    {isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
                </span>
            </div>

            {isOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        background: "#fff",
                        zIndex: 1000,
                        maxHeight: "200px",
                        overflowY: "auto"
                    }}
                >
                    {isSearch && (<input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search..."
                        disabled={disabled}
                        style={{
                            width: "100%",
                            padding: "8px",
                            border: "none",
                            borderBottom: "1px solid #ccc",
                            boxSizing: "border-box",
                            color: "#1E1E1E",
                            background: disabled ? "#f5f5f5" : "#fff"
                        }}
                    />)}

                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((option, index) => (
                            <div
                                key={index}
                                onClick={() => selectOption(option)}
                                style={{
                                    padding: "10px",
                                    cursor: "pointer",
                                    background:
                                        selectedOption && selectedOption.id === option.id
                                            ? "#f0f0f0"
                                            : "#fff",
                                    color: "#1E1E1E",
                                    textAlign: "left"
                                }}
                            >
                                {option.label}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: "10px", textAlign: "center" }}>
                            No records found.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CustomDropdownWithSearchStatic;
